import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { Wallet } from "lucide-react";

export default function PTCWallet() {
  const { authAxios } = useAuth();
  const { tr } = useLang();
  const [wallet, setWallet] = useState(null);
  const [txns, setTxns] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [w, t] = await Promise.all([
          authAxios.get("/ptc/wallet"),
          authAxios.get("/ptc/transactions"),
        ]);
        setWallet(w.data); setTxns(t.data);
      } catch (e) {}
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-10">
        <div className="pfi-overline inline-flex items-center gap-2"><Wallet size={12} /> PERSONA 5.0</div>
        <h1 className="mt-3 font-serif text-3xl sm:text-4xl" data-testid="ptc-title">{tr("p5_ptc_title")}</h1>
        <p className="mt-2 text-[#a9a9b8] text-sm">{tr("p5_ptc_sub")}</p>

        <div className="mt-8 pfi-card p-8" data-testid="ptc-balance-card">
          <div className="pfi-overline">{tr("p5_ptc_balance")}</div>
          <div className="mt-3 font-serif text-5xl text-[#e6c687]">
            {wallet ? wallet.balance : "—"} <span className="text-lg text-[#a9a9b8]">PTC</span>
          </div>
          {wallet ? <div className="mt-2 text-xs font-mono text-[#6c6c7a]">wallet {wallet.wallet_id}</div> : null}
        </div>

        <div className="mt-10">
          <div className="pfi-overline">{tr("p5_ptc_txns")}</div>
          <div className="mt-4 space-y-2">
            {txns.length === 0 ? (
              <div className="pfi-card p-6 text-sm text-[#a9a9b8]">{tr("p5_ptc_empty")}</div>
            ) : txns.map((t) => (
              <div key={t.transaction_id} className="pfi-card p-4 flex items-center justify-between gap-3" data-testid={`ptc-txn-${t.transaction_id}`}>
                <div className="min-w-0">
                  <div className="pfi-overline">{new Date(t.created_at).toLocaleString()} · {t.rule_id}</div>
                  <div className="mt-1 text-sm text-[#f8f8fc] truncate">{t.description}</div>
                  <div className="mt-1 text-[11px] font-mono text-[#6c6c7a]">
                    {t.balance_before} → {t.balance_after}
                  </div>
                </div>
                <div className={"font-serif text-xl shrink-0 " + (t.amount >= 0 ? "text-[#10B981]" : "text-red-300")}>
                  {t.amount >= 0 ? "+" : ""}{t.amount}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
